import "./StockModal.scss";
import { useState } from "react";
import { useAlert } from "react-alert";
import { useTranslation } from "react-i18next";
import { collection, deleteDoc, doc, getDocs, query, where } from "firebase/firestore";
import StockModal from "./StockModal";
import { db } from "../../../../firebase";

export default function DeleteStockCategoryModal({ open, onClose, onDeleted, category, venueId }) {
  const { t } = useTranslation("stockManagement");
  const alert = useAlert();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const closeModal = () => {
    if (isSubmitting) return;
    onClose();
  };

  const submitHandler = async () => {
    if (!category?.id) return;
    try {
      setIsSubmitting(true);

      const stockItemsQuery = query(
        collection(db, "StockItems"),
        where("venueId", "==", venueId),
        where("categoryId", "==", category.id),
      );
      const stockItemsSnapshot = await getDocs(stockItemsQuery);

      if (stockItemsSnapshot.size > 0) {
        alert.show(t("delete_stock_category_modal_has_items_error"), { type: "error" });
        return;
      }

      await deleteDoc(doc(db, "StockCategories", category.id));
      await onDeleted();
    } catch (error) {
      alert.show(t("delete_stock_category_modal_submit_error"), { type: "error" });
      console.error("Error deleting stock category:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <StockModal
      open={open}
      onClose={closeModal}
      onConfirm={submitHandler}
      isLoading={isSubmitting}
      title={t("delete_stock_category_modal_title", {
        name: category?.name ? ` - ${category.name}` : "",
      })}
    >
      <div className="stock-action-modal-products">
        <div className="stock-delete-warning-card">
          <div className="stock-delete-warning-card-content">
            <p className="stock-action-modal-warning-title">
              {t("stock_delete_modal_warning_title")}
            </p>
            <p className="stock-action-modal-products-subtitle">
              {t("delete_stock_category_modal_confirm_text")}
            </p>
            <p className="stock-action-modal-products-subtitle">
              {t("delete_stock_category_modal_warning")}
            </p>
          </div>
        </div>
      </div>
    </StockModal>
  );
}
